import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostOrdersPrepareBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Batch-transitions orders from pending → prepared, committing explicit batch allocations. */
export function usePrepareOrders() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostOrdersPrepareBody) => {
      const response = await api.post('/orders/prepare', { body })
      if (!response.success) throw new Error(response.error.message)
      return response.data.results
    },
    onSuccess: (orders) => {
      queryClient.invalidateQueries({ queryKey: ['orders'] })
      queryClient.invalidateQueries({ queryKey: ['products'] })
      queryClient.invalidateQueries({ queryKey: ['product'] })
      for (const id of new Set(orders.map((o) => o.patientId))) {
        queryClient.invalidateQueries({ queryKey: ['patient-orders', id] })
        queryClient.invalidateQueries({ queryKey: ['patient-treatments', id] })
        queryClient.invalidateQueries({ queryKey: ['patient-timeline', id] })
      }
      for (const id of new Set(
        orders.flatMap((o) => (o.consultationId ? [o.consultationId] : []))
      )) {
        queryClient.invalidateQueries({ queryKey: ['consultation', id] })
      }
    },
  })
}
